import {
  getSavedConcurrencyObject,
  setSavedConcurrencyObject,
} from '@tv2-player/unifiedplayer/src/store/savedConcurrencyObject';
// eslint-disable-next-line monorepo-dependencies/no-unlisted-package-import
import type { LoadRequestData } from 'chromecast-caf-receiver/cast.framework.messages';
import { ClientPlatform } from '@tv2-player/unifiedplayer';
import { beforeFetchMediaAction, mediaFilter } from '../extensions';
import { deviceDetector } from '../../utils/deviceDetector';
import { version } from '../../../release.json';
import type { ChromecastPlayRequestCustomData } from '../../types';
import { getChromecastUser } from '../../utils/getChromecastUser';
import { makeMediaObject } from '../../services/media';

export class ConcurrencyPlugin {
  init() {
    beforeFetchMediaAction.register(this.beforeFetchMedia.bind(this));
    mediaFilter.register(this.mediaTransform.bind(this));
  }

  async beforeFetchMedia(loadRequestData: LoadRequestData) {
    const concurrency = getSavedConcurrencyObject();
    if (concurrency) {
      const clientPlatform = {
        name: 'Chromecast',
        audience: 'PLAY',
        class: deviceDetector(),
        version,
      } as ClientPlatform;
      const customData = loadRequestData.customData as ChromecastPlayRequestCustomData;
      const user = getChromecastUser(customData);
      const body = {
        ...concurrency.body,
        concurrencyAction: 'UNLOCK',
        progress: null,
      };
      setSavedConcurrencyObject(undefined);
      fetch(concurrency.url, {
        method: 'POST',
        keepalive: true,
        body: JSON.stringify(body),
        headers: {
          Authorization: `Bearer ${user.accessToken}`,
          'Content-Type': 'application/json',
          'Client-Platform-Class': clientPlatform.class,
          'Client-Platform': clientPlatform.name,
          'Client-Platform-Audience': clientPlatform.audience,
          'Client-Platform-AppVersion': clientPlatform.version!,
          'Client-Platform-User-Profile': `${user?.selectedProfile?.profileToken ?? ''}`,
        },
      });
    }
  }

  async mediaTransform(media: ReturnType<typeof makeMediaObject>, accessToken: string) {
    setSavedConcurrencyObject(media.concurrency);
    return media;
  }
}
